import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import _ from 'lodash';
import { PureClientCode } from './ClientCode';

const options = [
  { id: '1008', text: '1008' },
  { id: '1009', text: '1009' },
  { id: '1010', text: '1010' },
];


storiesOf('ClientCode', module)
  .addWithJSX('SearchClientCode', () => (
    <PureClientCode
      sessionClientCode=""
      dispatch={action('dispatch')}
      onClientCodeSuggestionsRequested={action('onClientCodeSuggestionsRequested')}
      onClick={action('onClick')} />
  ))
  .addWithJSX('ClientCodefromSession', () => (
    <PureClientCode
      clientCodeSuggestions={options}
      onClientCodeSuggestionsRequested={action('onClientCodeSuggestionsRequested')}
      dispatch={action('dispatch-remove')}
      sessionClientCode="119-Session"
      onClick={action('onClick')} />
  ))
  // example of adding in some more states
  .add('Show Loading State', () => (
    <PureClientCode
      initialClientCode=""
      clientCodeList={options}
      hasMadeRequest
      loadedPrevClientCodeList={false}
      dispatch={action('dispatch')}
      sessionClientCode="" />
  ))
  .add('Locked', () => (
    <PureClientCode
      initialClientCode="blah"
      isClientCodeLocked={true}
      clientCodeList={[]}
      dispatch={action('dispatch')}
      onClientCodeSuggestionsRequested={action('ShouldNotDispatchAnyActionsWhenDisabled!')}
      onClick={action('ShouldNotDispatchAnyActionsWhenDisabled!')}
      />
  ))
  .add('Show New Code and Partial Match', () => (
    <PureClientCode
      initialClientCode=""
      clientCodeList={options}
      hasMadeRequest={false}
      loadedPrevClientCodeList={false}
      dispatch={action('dispatch')}
      sessionClientCode="New code: 100"
      placeholder="100"
      autoFocus
      openOnFocus />
  ))
  .addWithJSX('ClientCodeMsg', () => (
    withWindow()
  ));

function withWindow() {
  _.set(window, 'Drupal.settings.clientCodeChanged', true);
  _.set(window, 'Drupal.settings.clientCode', 'abc');

  return (
    <PureClientCode
      dispatch={action('dispatch')}
      onClientCodeSuggestionsRequested={action('onClientCodeSuggestionsRequested')}
      onClick={action('onClick')}
      sessionClientCode="123"
    />
  );
}



// WEBPACK FOOTER //
// ./src/clientCode/clientCode.stories.jsx